import axios from "axios";

// The console-guide endpoints return the PDF as raw bytes, not JSON, so a plain axios.post
// won't do — and with responseType "blob", error responses arrive as a Blob too, not parsed
// JSON, so the FastAPI {detail} message needs to be read back out of it by hand.
export async function fetchPdfObjectUrl(url, body, headers = {}) {
  try {
    const res = await axios.post(url, body, { headers, responseType: "blob" });
    return URL.createObjectURL(res.data);
  } catch (err) {
    let detail = "Request failed";
    const blob = err?.response?.data;
    if (blob instanceof Blob) {
      try {
        const parsed = JSON.parse(await blob.text());
        if (parsed?.detail) detail = parsed.detail;
      } catch {
        // Not JSON — keep the generic message.
      }
    } else if (err?.response?.data?.detail) {
      detail = err.response.data.detail;
    }
    throw new Error(detail);
  }
}
